<template>
    <div>Logout</div>
</template>
<script>
import auth from '@/services/authentication';

export default {
    mounted () {
        auth.signOut();
    },
};
</script>
